import Subscription from "interfaces/response/Subscription";
import { getDataAsync, postDataAsync } from "./PortalApi";
import ChangeSubscriptionRequest from "interfaces/request/ChangeSubscriptionRequest";
import SubscriptionResponse from "interfaces/response/SubscriptionResponse";
import SubscriptionChangePreviewResponse from "interfaces/response/SubscriptionChangePreviewResponse";

export const getSubscriptionBySubscriptionIdAsync = async (
  subscriptionId: number
) => {
  const url = `Subscriptions/${subscriptionId}`;
  return await getDataAsync<Subscription>(url);
};

export const subscribeToDefaultProductAndDefaultFreeSubscriptionAsync =
  async () => {
    const url = "Users/Products/Default/Subscriptions/DefaultFree";
    return await postDataAsync<any, any>(url, null);
  };

export const registerToService = async (
  productId: number,
  data: ChangeSubscriptionRequest
) => {
  const routeUrl = `Users/Products/${productId}/Subscriptions`;
  return await postDataAsync<any, SubscriptionResponse>(routeUrl, data);
};

export const changeSubscription = async (
  subscriptionId: number,
  data: ChangeSubscriptionRequest
) => {
  const routeUrl = `/Subscriptions/${subscriptionId}/Change`;
  return await postDataAsync<any, SubscriptionResponse>(routeUrl, data);
};

export const getSubscriptionUpdatePreviewAsync = (
  subscriptionId: number,
  subscriptionChangeRequest: ChangeSubscriptionRequest
) => {
  const url = `Subscriptions/${subscriptionId}/Change/Preview`;
  return postDataAsync<
    ChangeSubscriptionRequest,
    SubscriptionChangePreviewResponse
  >(url, subscriptionChangeRequest);
};

export const cancelScheduledSubscriptionChange = (subscriptionId: number) => {
  const url = `Subscriptions/${subscriptionId}/CancelScheduledChange`;
  return postDataAsync(url, null);
};
